import { faLink } from "@fortawesome/pro-regular-svg-icons";
import { Tooltip } from "@mui/material";

import { Icon } from "@/components/ui-v2/Icon/Icon";

import { INDICATOR_CLASS, IndicatorContainer } from "./shared";

export const LinkIndicator = () => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <Tooltip title="This model is linked to your workspace">
      <IndicatorContainer className={INDICATOR_CLASS} onClick={handleClick}>
        <Icon icon={faLink} style={{ fontSize: "14px" }} />
      </IndicatorContainer>
    </Tooltip>
  );
};
